import axios from 'axios';

const baseUrl = `${process.env.VUE_APP_API_BASEURL}/Files`;
const headers = { 'Content-Type': 'multipart/form-data' };

export default {
  async uploadFile(file, registrationId, registrationFileType, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('registrationFileType', registrationFileType);
    formData.append('registrationId', registrationId);

    try {
      const resp = await axios.post(baseUrl, formData, { headers, onUploadProgress });
      return resp.data;
    } catch (error) {
      console.error('File upload failed', {
        registrationId,
        registrationFileType,
        message: error?.message,
      });
      throw error;
    }
  },
};
